"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PhoneStatusesFinal = exports.PhoneStatuses = void 0;
exports.PhoneStatuses = [
    "pending",
    "accepted",
    "queued",
    "failed",
    "sending",
    "sent",
    "undelivered",
    "delivered",
    "received",
];
/**
 * Once a Twilio message reaches one of these statuses,
 * it is final.
 */
exports.PhoneStatusesFinal = [
    "failed",
    "undelivered",
    "delivered",
    "received",
];
//# sourceMappingURL=status.js.map